export interface DependencyProps {
  dependencyId: string;
  dependencyName: string;
  superiorName: string;
  superiorUrlParameterName?: string;
  dependentName: string;
  condition: {
    operator: string;
    threshold: string;
  };
  action: DependencyAction;
  actionNegative: DependencyAction;
  dependencySourceType: DependencySourceType | string;
  dependencySourceId: string;
}

export interface DependencyAction {
  effect: string;
  value: string;
  additionalProps?: string; // json data, workaround for prefill actions
}

export enum DependencyEffect {
  SHOW = 'show',
  HIDE = 'hide',
}

export enum DependencySourceType {
  FIELD = 'field',
  THIRD_PARTY_SYSTEM = 'thirdPartySystem',
  URL_PARAMETER = 'urlParameter',
}
